import React from "react";
import PropTypes from "prop-types";
import SFTypography from "../typography";
import { SFStack } from "../grid";
import { useTranslation } from "react-i18next";

const SFEmptyPlaceholder = ({ message = null }) => {
  const { t } = useTranslation();
  return (
    <SFStack justifyContent="center" alignItems="center">
      <SFTypography variant="body2" color="grey300">
        {message ?? t("components.emptyPlaceholder.message")}
      </SFTypography>
    </SFStack>
  );
};

SFEmptyPlaceholder.propTypes = {
  // custom placeholder message
  message: PropTypes.string,
};

export default SFEmptyPlaceholder;
